import { render, staticRenderFns } from "./RecoProducts.vue?vue&type=template&id=7d8ef926&scoped=true&"
import script from "./RecoProducts.vue?vue&type=script&lang=ts&"
export * from "./RecoProducts.vue?vue&type=script&lang=ts&"
import style0 from "./RecoProducts.vue?vue&type=style&index=0&id=7d8ef926&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8ef926",
  null
  
)

export default component.exports